/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FoodDrinkCupTakeawayIcon16Solid = forwardRef('FoodDrinkCupTakeawayIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M4.075 2.29 3.882 3H8a.5.5 0 0 1 0 1H3.25a1 1 0 0 0 0 2h9.5a1 1 0 1 0 0-2h-.359l-.466-1.71A1.75 1.75 0 0 0 10.236 1H5.764c-.79 0-1.48.528-1.689 1.29Z" }),
        React.createElement("path", { d: "M4.158 13.438 3.462 7h9.076l-.696 6.438A1.75 1.75 0 0 1 10.102 15H5.898a1.75 1.75 0 0 1-1.74-1.562Z" })));
});
